export enum UserCreateStatusEnum {
    ALREADY_EXISTS = 'ALREADY_EXISTS',
    OK = 'OK',
}
